import * as Yup from 'yup'

export const ChargeBandsCreateSchema = Yup.object().shape({
    charge_band_name: Yup.string().required('Charge Band Name is required'),
    charge_band_type: Yup.string().required('Charge Band Type is required'),
    charge_band_year: Yup.string().required('Charge Band Year is required'),
    ndis_price_list_id: Yup.string().required('Support Item Name is required'),
});
